import { render, staticRenderFns } from "./SanityContent.vue?vue&type=template&id=31639084"
import script from "./SanityContent.vue?vue&type=script&lang=js"
export * from "./SanityContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports